import { Listing } from '@smg-real-estate/hg-rets-schema';

export const getContactFormBlockTime = (listing: Listing | undefined): string => {
  if (listing && listing.valueAddedServices?.exclusiveUntil) {
    const blockedUntilDate = new Date(listing.valueAddedServices.exclusiveUntil);
    const remainingBlockTime = (blockedUntilDate.getTime() - new Date().getTime()) / 3600000 / 24;

    return Math.ceil(remainingBlockTime).toString();
  }

  return '';
};
